/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type {CancelablePromise} from '../core/CancelablePromise';
import {OpenAPI} from '../core/OpenAPI';
import {request as __request} from '../core/request';
import {BatchAcknowledgementSaveDto} from '../models/BatchAcknowledgementSaveDto';
import {BatchAcknowledgementDto} from '../models/BatchAcknowledgementDto';
import { MyAcknowledgementDto } from '../models/MyAcknowledgementDto';
import { BatchAcknowledgementNotCompletedDto } from '../models/BatchAcknowledgementNotCompletedDto';
import { DocumentDto } from '../models/DocumentDto';
import { UnitsProcessDto } from '../models/UnitsProcessDto';
import { ProcessDto } from '../models/ProcessDto';
import { AcknowledgementsProcessDto } from '../models/AcknowledgementsProcessDto';
import { AcknowledgementTemplateDto } from '../models/AcknowledgementTemplateDto';

export class AcknowledgementService {



  /**
   * @param id
   * @returns BatchAcknowledgementDto Success
   * @throws ApiError
   */
  public static getApiBatchAcknowledgement(
    batchId: number
  ): CancelablePromise<BatchAcknowledgementDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/acknowledgement/{batchId}',
      path: {
        batchId: batchId
      }
    });
  }

  /**
   * @param id
   * @returns DocumentDto[] Success
   * @throws ApiError
   */
  public static getApiDocumentsUsedInUnit(
    unitId: number
  ): CancelablePromise<DocumentDto[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/acknowledgement/document/{unitId}',
      path: {
        unitId: unitId
      }
    });
  }

  /**
   * @param id
   * @returns AcknowledgementsProcessDto[] Success
   * @throws ApiError
   */
  public static getApiProcessesUsedInUnit(
    unitId: number
  ): CancelablePromise<AcknowledgementsProcessDto[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Acknowledgement/process/{unitId}',
      path: {
        unitId: unitId
      }
    });
  }



   /**
   * @param id
   * @returns BatchAcknowledgementNotCompletedDto[] Success
   * @throws ApiError
   */
   public static getUserWithDataToAcknowledge(
    batchId: number
  ): CancelablePromise<BatchAcknowledgementNotCompletedDto[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Acknowledgement/readUserWithDataToAcknowledge/{batchId}',
      path: {
        batchId: batchId
      }
    });
  }

   /**
   * @returns MyAcknowledgementDto[] Success
   * @throws ApiError
   */
   public static getApiMyInitiatedAcknowledgements(
  ): CancelablePromise<MyAcknowledgementDto[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Acknowledgement/readMyInitiated',
    });
  }

  /**
   * @returns MyAcknowledgementDto[] Success
   * @throws ApiError
   */
   public static getApiReceivedAcknowledgements(
  ): CancelablePromise<MyAcknowledgementDto[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Acknowledgement/readReceived',
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns BatchAcknowledgementSaveDto
   * @throws ApiError
   */
  public static postApiBatchAcknowledgement(
    requestBody: BatchAcknowledgementSaveDto
  ): CancelablePromise<Array<BatchAcknowledgementSaveDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Acknowledgement/create',
      body: requestBody,
      mediaType: 'application/json'
    });
  }


  /**
   * @param id
   * @returns AcknowledgementTemplateDto Success
   * @throws ApiError
   */
  public static getUnitAcknowledgementTemplates(
    unitId: number
  ): CancelablePromise<AcknowledgementTemplateDto[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/acknowledgement/template/unit/{unitId}',
      path: {
        unitId: unitId
      }
    });
  }

   /**
   * @param id
   * @returns AcknowledgementTemplateDto Success
   * @throws ApiError
   */
  public static getTemplateById(
    id: number
  ): CancelablePromise<AcknowledgementTemplateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/acknowledgement/template/{id}',
      path: {
        id: id
      }
    });
  }

  /**
   * @param requestBody
   * @returns AcknowledgementTemplateDto
   * @throws ApiError
   */
  public static postApiCreateAcknowledgementTemplate(
    requestBody: AcknowledgementTemplateDto
  ): CancelablePromise<AcknowledgementTemplateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Acknowledgement/template/create',
      body: requestBody,
      mediaType: 'application/json'
    });
  }

    /**
   * @param unitId
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static deleteTemplate(unitId: number, id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Acknowledgement/template/unit/{unitId}/delete/{id}',
      path: {
        unitId: unitId,
        id: id
      }
    });
  }

  /**
   * @param requestBody
   * @returns AcknowledgementTemplateDto
   * @throws ApiError
   */
  public static postApiUpdateAcknowledgementTemplate(
    requestBody: AcknowledgementTemplateDto
  ): CancelablePromise<Array<AcknowledgementTemplateDto>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Acknowledgement/template/update',
      body: requestBody,
      mediaType: 'application/json'
    });
  }

  /**
   * @param id
   * @throws ApiError
   */
  public static putAcknowledgementOpened(id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Acknowledgement/opened/{id}',
      path: {
        id: id
      },
      mediaType: 'application/json'
    });
  }

  /**
   * @param id
   * @throws ApiError
   */
  public static putAcknowledgementConfirmed(id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Acknowledgement/confirmed/{id}',
      path: {
        id: id
      },
      mediaType: 'application/json'
    });
  }

  /**
   * @param id
   * @throws ApiError
   */
  public static putAcknowledgementFinished(batchId: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Acknowledgement/finish/{batchId}',
      path: {
        batchId: batchId
      },
      mediaType: 'application/json'
    });
  }



}




